import {
  CREATE_AGREMEENT_SUCCESS,
  CREATE_AGREMEENT_FAIL,
  RETRIEVE_AGREMEENT_SUCCESS,
  RETRIEVE_AGREMEENT_FAIL,
  UPDATE_AGREMEENT_SUCCESS,
  UPDATE_AGREMEENT_FAIL,
  DELETE_AGREMEENT_SUCCESS,
  DELETE_AGREMEENT_FAIL,
} from "../actions/types";

const initialState = [];

function Reducer(datas = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CREATE_AGREMEENT_SUCCESS:
      return [...datas, payload];

    case RETRIEVE_AGREMEENT_SUCCESS:
      return payload;

    case RETRIEVE_AGREMEENT_FAIL:
      return [...datas];

    case UPDATE_AGREMEENT_SUCCESS:
      return datas.map((data) => {
        if (data.uuid === payload.uuid) {
          return {
            ...datas,
            ...payload,
          };
        } else {
          return data;
        }
      });

    case DELETE_AGREMEENT_SUCCESS:
      return datas.filter(({ uuid }) => uuid !== payload.uuid);

    default:
      return datas;
  }
}

export default Reducer;
